import React from "react";
import PropTypes from "prop-types";
import Modal from "components/base/SimpleModal";
import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority,
} from "app/PopupHolder";

import css from "./style.scss";


/**
 * Renders Info Alert dialog
 * Used in:
 * I) My properties, My contacts page
 */
// `wrapperClassName` goes on SimpleModal's backdrop/wrapper (z-index 9999), so a
// caller that opens this from inside a higher overlay can lift it above that
// overlay (PROPS-3844: SkipTraceModal sits at 10002).
const InfoAlert = ({ closePopup, yesRedirect, autoWidth, infoText, title, uniqId = `${new Date().getTime()}-InfoAlert`, cancelText = 'OK', wrapperClassName }) => {
  const handleClose = () => {
    closePopup();
  };

  return (
    <Modal
      uniqId={uniqId}
      onCancel={handleClose}
      title={title}
      description={infoText}
      cancelText={cancelText}
      onSubmitRedirect={yesRedirect}
      modalClassName={css.clsInfoAlert}
      wrapperClassName={wrapperClassName}
    />
  );
};

export default InfoAlert;

const registrationId = getPopupRegistration(InfoAlert);

InfoAlert.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.HIGHEST });
InfoAlert.close = () => closePopup({ popup: registrationId });

InfoAlert.propTypes = {
  /** Closes the popup */
  closePopup: PropTypes.func.isRequired,
  /** Redirects to the given URL */
  yesRedirect: PropTypes.func,
  /** Whether the popup should be auto-width */
  autoWidth: PropTypes.bool,
  /** The text to display in the popup */
  infoText: PropTypes.string.isRequired,
  /** The title of the popup */
  title: PropTypes.string.isRequired,
  /** The unique ID of the popup */
  uniqId: PropTypes.string,
  /** The cancel text */
  cancelText: PropTypes.string,
};
